import { defineMessages } from 'react-intl';


export const LOCALIZED_STRINGS = defineMessages({
    DateRangeTextLessThan1Month: {
        id: 'Profile.Components.Review.DateRangeText',
        defaultMessage: 'Less than 1 month ago',
    },
    DateRangeTextLessThan3Months: {
        id: 'Profile.Components.Review.DateRangeText',
        defaultMessage: 'Less than 3 months ago',
    },
    DateRangeTextLessThan6Months: {
        id: 'Profile.Components.Review.DateRangeText',
        defaultMessage: 'Less than 6 months ago',
    },
    DateRangeTextLessThan1Year: {
        id: 'Profile.Components.Review.DateRangeText',
        defaultMessage: 'Less than 1 year ago',
    },
    DateRangeTextMoreThan1Year: {
        id: 'Profile.Components.Review.DateRangeText',
        defaultMessage: 'More than 1 year ago',
    },
    InitialsHidden: {
        id: 'Profile.Components.Review.InitialsHidden',
        defaultMessage: 'Initials hidden',
    },
    MailedInByLine: {
        id: 'Profile.Components.Review.MailedInByLine',
        defaultMessage: '{patientName}',
    },
    ReviewSource: {
        id: 'Profile.Components.Review.ReviewSource',
        defaultMessage: 'Source: {sourceName}',
    },
    VerifiedPatientByLine: {
        id: 'Profile.Components.Review.VerifiedPatientByLine',
        defaultMessage: '{patientName}, verified patient',
    },
});
